module.exports = __webpack_public_path__ + "img/0bde5a8.svg";